import { DEFAULT_VARIANT, Icon } from "../Icon.js";
import { jsx } from "react/jsx-runtime";
import { useTranslation } from "react-i18next";

//#region src/components/icon/variants/IconSend.tsx
const OutlinedFilledSend = (props) => /* @__PURE__ */ jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 -960 960 960",
	...props,
	children: /* @__PURE__ */ jsx("path", { d: "M97-136v-248l336-96-336-98v-246l813 344L97-136Z" })
});
const OutlinedSend = (props) => /* @__PURE__ */ jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 -960 960 960",
	...props,
	children: /* @__PURE__ */ jsx("path", { d: "M97-136v-688l813 344L97-136Zm83-128 516-216-516-219v146l253 73-253 71v145Zm0 0v-435 435Z" })
});
const RoundedFilledSend = (props) => /* @__PURE__ */ jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 -960 960 960",
	...props,
	children: /* @__PURE__ */ jsx("path", { d: "M163-165q-24 10-45-3.5T97-207v-177l336-96-336-98v-175q0-25 21-38.5t45-4.5l644 272q29 12 29 44t-29 44L163-165Z" })
});
const RoundedSend = (props) => /* @__PURE__ */ jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 -960 960 960",
	...props,
	children: /* @__PURE__ */ jsx("path", { d: "M807-436 163-165q-24 10-45-3.5T97-207v-546q0-25 21-38.5t45-4.5l644 272q29 12 29 44t-29 44ZM180-264l516-216-516-219v146l253 73-253 71v145Zm0 0v-435 435Z" })
});
const SharpFilledSend = (props) => /* @__PURE__ */ jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 -960 960 960",
	...props,
	children: /* @__PURE__ */ jsx("path", { d: "M97-136v-248l336-96-336-98v-246l813 344L97-136Z" })
});
const SharpSend = (props) => /* @__PURE__ */ jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 -960 960 960",
	...props,
	children: /* @__PURE__ */ jsx("path", { d: "M97-136v-688l813 344L97-136Zm83-128 516-216-516-219v146l253 73-253 71v145Zm0 0v-435 435Z" })
});
const componentMap = {
	outlined: OutlinedSend,
	"outlined-fill": OutlinedFilledSend,
	rounded: RoundedSend,
	"rounded-fill": RoundedFilledSend,
	sharp: SharpSend,
	"sharp-fill": SharpFilledSend
};
const IconSend = ({ color, filled, height, variant = "rounded", style = {}, width, "data-testid": testId }) => {
	const { t } = useTranslation("pds");
	return /* @__PURE__ */ jsx(Icon, {
		SvgIcon: componentMap[`${variant}${filled ? "-fill" : ""}`] ?? componentMap[DEFAULT_VARIANT],
		alt: t(""),
		"data-testid": testId,
		color,
		style,
		height,
		width
	});
};

//#endregion
export { IconSend };